import { API } from "aws-amplify";
import { signup as signupGqlMutation } from "../../graphql/mutations";
import { GraphQLQuery } from "@aws-amplify/api";
import { SignupInput, SignupMutation, SignupResponse } from "../../API";
import { useCallback } from "react";

export function useSignup() {
    const signup = useCallback(
        async (input: SignupInput): Promise<SignupResponse | null> => {
            const result = await API.graphql<GraphQLQuery<SignupMutation>>({
                query: signupGqlMutation,
                variables: { input },
            });

            return result.data?.signup || null;
        },
        []
    );

    return { signup };
}
